// extracted by mini-css-extract-plugin
module.exports = {"vertical":"form-input-group_vertical__2OXXA","horizontal":"form-input-group_horizontal__3nHTu"};